import React, { useState, useEffect, useRef } from 'react';

const LoadingSpinner = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '60px 20px',
      minHeight: '200px',
    }}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
      }}
    >
      <div
        className="spinner"
        style={{
          width: '50px',
          height: '50px',
          border: '4px solid rgba(102, 126, 234, 0.2)',
          borderTop: '4px solid #667eea',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }}
      ></div>
      <p
        style={{
          color: '#667eea',
          fontSize: '16px',
          fontWeight: '600',
          margin: 0,
        }}
      >
        Memuat konten...
      </p>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  </div>
);

const LazySection = ({ children, minHeight = '400px' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [shouldLoad, setShouldLoad] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    // Early return if already loading/loaded - prevents re-initialization
    if (shouldLoad) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setShouldLoad(true);
            // Small delay to show loading state, then load content
            setTimeout(() => {
              setIsVisible(true);
            }, 300);
          }
        });
      },
      {
        rootMargin: '100px', // Start loading 100px before component enters viewport
        threshold: 0.01,
      }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      style={{
        minHeight: minHeight,
        position: 'relative',
        opacity: isVisible ? 1 : 0.8,
        transition: 'opacity 0.3s ease-in-out'
      }}
    >
      {!isVisible && shouldLoad && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 10
        }}>
          <LoadingSpinner />
        </div>
      )}
      <div style={{
        visibility: isVisible ? 'visible' : 'hidden',
        minHeight: minHeight
      }}>
        {shouldLoad && children}
      </div>
    </div>
  );
};

export default LazySection;
